import { render, staticRenderFns } from "./NavegacionFichaFijo.vue?vue&type=template&id=153d0352&scoped=true&"
import script from "./NavegacionFichaFijo.vue?vue&type=script&lang=js&"
export * from "./NavegacionFichaFijo.vue?vue&type=script&lang=js&"
import style0 from "./NavegacionFichaFijo.vue?vue&type=style&index=0&id=153d0352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153d0352",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSystemBar } from 'vuetify/lib/components/VSystemBar';
installComponents(component, {VIcon,VSystemBar})
